export const Color = {
    white: 'white',
    black50: 'black-50', //#808080
    paleGray: 'pale-gray', //#f4f6f9
    softRed: 'soft-red', //#ffe8ed
    mango: 'mango' //#ff8000
};
